import { render, staticRenderFns } from "./suitch-generic.vue?vue&type=template&id=af07662a&"
import script from "./suitch-generic.vue?vue&type=script&lang=js&"
export * from "./suitch-generic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports